<template>
  <div>
    <Modal
      header="Search Business"
      class="calico-search-dialog"
      @close="$emit('close')"
    >
      <template #content>
        <CalicoForm
          v-slot="{ field, error }"
          name="businessName"
          label="Business Name"
        >
          <CalicoField
            v-model="businessName"
            v-bind="field"
            :error="error"
            placeholder="Enter a business name"
          />
        </CalicoForm>

        <CalicoForm
          v-slot="{ field, error }"
          name="state"
          label="State"
        >
          <CalicoDropdown
            v-model="state"
            v-bind="field"
            :error="error"
            placeholder="Select..."
          >
            <CalicoDropdownMenuItem
              v-for="option in states"
              :key="option.value"
              class="calico-option body--medium"
              :value="option.value"
              @click="state = option.value"
            >
              {{ option.label }}
            </CalicoDropdownMenuItem>
          </CalicoDropdown>
        </CalicoForm>

        <div class="address">
          <CalicoForm
            v-slot="{ field, error }"
            name="city"
            label="City"
          >
            <CalicoField
              v-model="city"
              v-bind="field"
              :error="error"
              placeholder="Enter city"
            />
          </CalicoForm>

          <CalicoForm
            v-slot="{ field, error }"
            name="zip"
            label="Zip"
          >
            <CalicoField
              v-model="zip"
              v-bind="field"
              :error="error"
              :only-numbers="true"
              placeholder="Enter zip"
            />
          </CalicoForm>
        </div>

        <CalicoForm
          v-slot="{ field, error }"
          name="industry"
          label="Industry"
        >
          <CalicoField
            v-model="industry"
            v-bind="field"
            :error="error"
          />
        </CalicoForm>
      </template>

      <template #footer>
        <button
          type="submit"
          class="button-primary"
          @click="handleSearchClick"
        >
          Search
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import CalicoField from '@/components/calico/field/index.vue'
import CalicoDropdown from '@/components/calico/dropdown/index.vue'
import CalicoDropdownMenuItem from '@/components/calico/dropdownMenuItem/index.vue'
import CalicoForm from '@/components/pattern/form/index.vue'
import { states } from "@/constants"
import Modal from "@/components/template/modal/index.vue"

export default {
  name: "CalicoSearchDialog",
  components: {
    CalicoField,
    CalicoForm,
    CalicoDropdown,
    CalicoDropdownMenuItem,
    Modal
  },
  props: {
    orgId: { type: [Number, String], default: null }
  },
  data() {
    return {
      industry: '',
      businessName: '',
      state: '',
      city: '',
      zip: '',
      states,
      page: 1,
      limit: 20,
    }
  },
  methods: {
    async handleSearchClick() {
      const params = {
        businessName: this.businessName,
        industry: this.industry,
        state: this.state,
        city: this.city,
        zip: this.zip,
        page: this.page,
        limit: this.limit

      }
      this.$router.push({ path: '/search-results', query: params })
      this.$emit("close")
    }
  }
}
</script>

<style lang="scss">
.calico-search-dialog {
  .content {
    @include inset-space($space-medium);
    @include stack-space($space-large);
    .address { @include inline-space($space-medium); }
  }
  div.footer { @include inset-space($space-large); }
}
</style>
